import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/(pages)/terms-and-conditions/Terms.jsx");
